
import Chord from '@tonaljs/chord'
import { getDegreeNotation } from '../../util/TonalUtils'
import { getId, toTt } from "../../util/utils"


export interface ChordNoTt {
	currentName: string,
	aliases: string[],
	chroma: string,
	empty: boolean,
	intervals: string[],
	name: string,
	normalized: string,
	notes: string[],
	quality: string,
	root: string,
	rootDegree: number,
	setNum: number,
	symbol: string,
	tonic: string | null,
	type: string,
}

export interface Chord {
	currentName: string,
	degreeName?: string,// TODO : should not be optional
	transportTime: string,
	transportTimeDuration: string,
	// [x:string]: any,
	aliases: string[],
	chroma: string,
	empty: boolean,
	intervals: string[],
	name: string,
	normalized: string,
	notes: string[],
	quality: string,
	root: string,
	rootDegree: number,
	setNum: number,
	symbol: string,
	tonic: string | null,
	type: string,
	id: string,
}

export interface Section {
	name: string,
	transportTime: string,
	transportTimeDuration: string,
}

export interface EditorState {
	config: {
		scale: string
	},
	state: {
		chordEditIndex: number | undefined
		isPlaying: boolean
		playTransportTime: string | undefined
		chordSelectedRanges: [number, number][]
		cursorRanges: [string, string][]

		initialCursorDragTt: string | undefined
		lastTimeSelectGroup: number | undefined
		currChordSelectDragTt: string | undefined

		currChordSelectDragLineIndex: number | undefined
		currChordsSelectDragLineIndexes: number[] | undefined
		
		currChordDragIndex: number | undefined

		currAddChordTtD: string,
	},
	chords: Chord[],
	fakeChords: Chord[] | undefined,
	sections: Section[]
}

const initialScale = 'C major'

// const initialChords = 'Am_0_1 B7_1_0:2 Cm_1:3:3_0:1 Dm_2:3_0:3 E7_3:2_0:2 F7_5:2_0:2 F7_17:2_1:2 E7_25:2_1:2'.split(' ').map((chordData: any) => {
const initialChords = 'F7_4:2_2:2 G#7_9:2_0:2 A_13:2_0:2'.split(' ').map((chordData: any) => {
// const initialChords = 'F7_4:2_2:2'.split(' ').map((chordData: any) => {
	const chordDataArray = chordData.split('_')

	const chord = Chord.get(chordDataArray[0])

	return {
		currentName: chordDataArray[0],
		degreeName: getDegreeNotation(chord, initialScale),
		transportTime: toTt(chordDataArray[1]),
		transportTimeDuration: toTt(chordDataArray[2]),
		...chord,
		id: getId(),
	}
})

export const initialEditorState: EditorState = {
	config: {
		scale: initialScale
	},
	state: {
		chordEditIndex: undefined,
		isPlaying: false,
		playTransportTime: undefined,
		chordSelectedRanges: [],// TODO chordSelectedRanges from [start, end] to [start, duration]
		cursorRanges: [['0:0', '0:0']],

		initialCursorDragTt: undefined,
		lastTimeSelectGroup: undefined,// enable ctrl+a * 2 to select all
		currChordSelectDragTt: undefined,// use to not fire multiple time same ChordSelectDrag event

		currChordSelectDragLineIndex: undefined,
		currChordsSelectDragLineIndexes: undefined,// use to prevent rerender when chord cross a line
		
		currChordDragIndex: undefined,// use to multi drag and set event listeners

		// Controls
		currAddChordTtD: '1:0:0',
	},
	chords: initialChords,
	fakeChords: undefined,// used during chordDrag
	sections: [{
		name: 'A',
		transportTime: '0:0',
		transportTimeDuration: '16:0',
	}, {
		name: 'B',
		transportTime: '16:0',
		transportTimeDuration: '8:0',
	}, {
		name: 'C',
		transportTime: '24:0',
		transportTimeDuration: '4:0',
	}]
}


// export enum Status {
// 	NotStarted = 'Not Started',
// 	InProgress = 'In Progress',
// 	Finished = 'Finished',
// }

// export interface Player {
// 	name: string
// 	id: number
// 	status: Status
// 	value?: number
// }
